import React, { useState } from "react";
import SearchRedesignSvg from "../../../../../prod/images/redesign/search.svg?react";
import Button from "../Button/Button";

interface SearchBlockProps {
  blockTitle: string;
  searchPlaceholder: string;
}

export const SearchBlock: React.FC<SearchBlockProps> = ({
  blockTitle,
  searchPlaceholder,
}) => {
  const [searchTerm, setSearchTerm] = useState<string>("");

  const handleSubmit = (evt: React.FormEvent<HTMLFormElement>) => {
    evt.preventDefault();
    redirectToSerachPage();
  };

  const redirectToSerachPage = () => {
    const url = new URL(`${window.location.origin}/searchpage`);
    url.searchParams.append("term", searchTerm);
    window.location.href = url.toString();
  };

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSearchTerm(event.target.value);
  };

  return (
    <form
      className="flex flex-col w-full items-center px-5 py-7 md:py-20 mb-0 md:mb-28 bg-secondaryLightGreen"
      onSubmit={handleSubmit}
    >
      <div className="mb-20 text-2xl text-primary">{blockTitle}</div>
      <div className="mb-20 w-full justify-center flex">
        <div className="flex justify-between border-2 rounded bg-white border-primary px-4 w-[350px] md:w-[700px] text-sm">
          <input
            className="w-full focus:outline-none py-2"
            onChange={handleInputChange}
            placeholder={searchPlaceholder}
          />
          <button className="bg-white border-0 outline-0" type="submit">
            <SearchRedesignSvg />
          </button>
        </div>
      </div>
      <button
        className="leading-9 rounded flex items-center group px-6 bg-primary text-md text-white justify-center outline-none hover:bg-primaryBlue hover:border-primaryBlue hover:text-white hover:outline-none"
        type="submit"
      >
        Search
      </button>
    </form>
  );
};
